import React from 'react'
import PropTypes from 'prop-types'
import { Box, Container } from '@chakra-ui/react'
import FroalaEditorView from 'components/froala-editor/view'

const HtmlLayoutOne = ({ data, theme }) => {
  const getTwitterScript = () => {
    setTimeout(() => {
      let twitterScript = document.createElement('script')
      twitterScript.src = 'https://platform.twitter.com/widgets.js'
      twitterScript.charset = 'utf-8'
      document.body.appendChild(twitterScript)
    }, 2000)
  }

  return (
    <>
      {getTwitterScript()}
      <Box
        bg={theme.backgroundColor}
        color={theme.textColor}
        px={[1, 4, 8, 16]}
      >
        <Box py={8} px={[4, 4, 0, 0]}>
          <Container maxW='container.lg' mx='auto' px={0}>
            <FroalaEditorView
              model={data.html}
            />
          </Container>
        </Box>
      </Box>
    </>
  )
}

HtmlLayoutOne.propTypes = {
  data: PropTypes.object,
  theme: PropTypes.object
}

export default HtmlLayoutOne
